import ResetReadingGameBtn from './ResetReadingGameBtn';

export default ResetReadingGameBtn;
